import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getForSearch = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Log/Search", params);
};

export { getForSearch };
